export default __webpack_public_path__ + "components/switch-units/static/sailboat-8de9b8ac986ab55df9081410f7d26f9a.svg";